import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function MillenniumIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4151" data-mp="30r1bcrbkokra">
      
      <div className="relative w-full h-full bg-gradient-to-br from-fuchsia-300 via-pink-400 to-rose-500 overflow-hidden" data-id="element-4152" data-mp="35obch48bqkuy">
        {/* Background: Fireworks bursts */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4153" data-mp="3fnsftf03smnr">
          
          <g transform="translate(50, 45)" opacity="0.6" data-id="element-4154" data-mp="3jlzvs7mqtjxw">
            {[...Array(8)].map((_, i) => <path key={i} d="M0 0 L0 -22" stroke="#FDE047" strokeWidth="2" strokeLinecap="round" transform={`rotate(${i * 45})`} data-id="element-4155" data-mp="1laj3zgk34p2c" data-mpi={i} />)}
          </g>
          <g transform="translate(155, 55)" opacity="0.6" data-id="element-4156" data-mp="ytlu4lycg3n1">
            {[...Array(8)].map((_, i) => <path key={i} d="M0 0 L0 -16" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" transform={`rotate(${i * 45})`} data-id="element-4157" data-mp="u2n8r7yi0fcx" data-mpi={i} />)}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[8%]" data-id="element-4158" data-mp="p0xz9wqxc9qy">
          <div className="w-[66%] h-[66%] flex items-center justify-center" data-id="element-4159" data-mp="k236q335n6tn">
            <DjaySpecimen look={{
            variant,
            accessory: 'tripleStars'
          }} size="hero" emotion={isUnlocked ? 'excited' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4160" data-mp="1hrg00r46dz17" />
            
          </div>
        </div>

        {/* Foreground: "1000" banner */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4161" data-mp="12x1m34zgxfte">
          
            <path d="M-10 150 Q100 178 210 150 L210 200 L-10 200 Z" fill="#BE185D" opacity="0.85" data-id="element-4162" data-mp="3nk4vbnwucw6i" />
          
            <text x="100" y="184" textAnchor="middle" fontFamily="sans-serif" fontSize="26" fontWeight="900" fill="#FDE047" data-id="element-4163" data-mp="2flz4fqmd23yv">
            
              1000
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}